var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._v(" Vous avez des questions, nous pouvons vous aider. N'hésitez pas à nous contacter à l'adresse suivante: "),_c('div',[_c('a',{attrs:{"href":"mailto:info@ondagoapp.com"}},[_vm._v("info@ondagoapp.com")])])])
}]

export { render, staticRenderFns }